// extracted by mini-css-extract-plugin
export default {"settingsInput":"settings_settingsInput__Uamtl"};